import React, { useEffect, useState } from "react";
import {
   Button,
   Collapse,
   Menu,
   Dropdown,
   Modal,
   Form,
   Input,
   Select,
   Switch,
   Spin
} from "antd";
import { ImageUploader } from "../../../../components/ImageUploader";
import { Resource } from "../../../../api/common";
import useAxios from "axios-hooks";
import { Image, message, Tag } from "antd";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { getImagePath } from "../../../../utils/getImagePath";
import { getPassportWithUploadedMaterialImagesLinks } from "../AddMaterialWizard/ReusePotential/getUploadedMaterialPassportImagesLinks";
import { getAxiosInstance } from "../../../../utils/axios";
import { useFlagsmith } from "flagsmith-react";
import PassportIdentifier from "../../../../components/ui@concular/PassportIdentifier";
import { Mixpanel } from "../../../../utils/tracking/mixpanel";
import { Events } from "../../../../utils/tracking/tracking.events";

const { Panel } = Collapse;
const { Option } = Select;

const PassportCluster = ({
   passportCluster,
   material,
   refetch,
   showAddModal
}: any) => {
   const [isClusterModalVisible, setIsClusterModalVisible] = useState(false);
   const history = useHistory();
   const { pathname }: any = useLocation();
   const [t] = useTranslation();
   const { isLoading, isError, hasFeature } = useFlagsmith();
   const hasAgGridBulkEditFeature = hasFeature("ag_grid_passport_bulk_edit");
   const [isModalVisibleOnSale, setIsModalVisibleOnSale] = useState(false);
   const [onSaleCount, setOnSaleCount] = useState(
      passportCluster.on_sale_count
   );
   const [selectedMenuKey, setSelectedMenuKey] = useState(0);

   console.log({ hasAgGridBulkEditFeature });

   const conditions = [
      {
         label: t("staticDropdown.condition.originalPacked"),
         value: t("staticDropdown.condition.originalPacked")
      },
      {
         label: t("staticDropdown.condition.new"),
         value: t("staticDropdown.condition.new")
      },
      {
         label: t("staticDropdown.condition.likeNew"),
         value: t("staticDropdown.condition.likeNew")
      },
      {
         label: t("staticDropdown.condition.refurbished"),
         value: t("staticDropdown.condition.refurbished")
      },
      {
         label: t("staticDropdown.condition.signOfUsages"),
         value: t("staticDropdown.condition.signOfUsages")
      },
      {
         label: t("staticDropdown.condition.signOfAge"),
         value: t("staticDropdown.condition.signOfAge")
      },
      {
         label: t("staticDropdown.condition.heavilyUsed"),
         value: t("staticDropdown.condition.heavilyUsed")
      },
      {
         label: t("staticDropdown.condition.damaged"),
         value: t("staticDropdown.condition.damaged")
      },
      {
         label: t("staticDropdown.condition.broken"),
         value: t("staticDropdown.condition.broken")
      }
   ];
   const deconstructability = [
      {
         label: t("staticDropdown.deconstructability.easyLoose"),
         value: t("staticDropdown.deconstructability.easyLoose")
      },
      {
         label: t("staticDropdown.deconstructability.easyPlugged"),
         value: t("staticDropdown.deconstructability.easyPlugged")
      },
      {
         label: t("staticDropdown.deconstructability.easyScrewed"),
         value: t("staticDropdown.deconstructability.easyScrewed")
      },
      {
         label: t("staticDropdown.deconstructability.easyBuild"),
         value: t("staticDropdown.deconstructability.easyBuild")
      },
      {
         label: t("staticDropdown.deconstructability.moderateBuild"),
         value: t("staticDropdown.deconstructability.moderateBuild")
      },
      {
         label: t("staticDropdown.deconstructability.elaborateBuild"),
         value: t("staticDropdown.deconstructability.elaborateBuild")
      },
      {
         label: t("staticDropdown.deconstructability.hardSpecialSkillsNeeded"),
         value: t("staticDropdown.deconstructability.hardSpecialSkillsNeeded")
      },
      {
         label: t("staticDropdown.deconstructability.notEconomicallyFeasible"),
         value: t("staticDropdown.deconstructability.notEconomicallyFeasible")
      },
      {
         label: t("staticDropdown.deconstructability.notPossible"),
         value: t("staticDropdown.deconstructability.notPossible")
      }
   ];

   const customPollutance = [
      {
         label: t("staticDropdown.customPollutance.unknown"),
         value: t("staticDropdown.customPollutance.unknown")
      },
      {
         label: t("staticDropdown.customPollutance.toBeProved"),
         value: t("staticDropdown.customPollutance.toBeProved")
      },
      {
         label: t("staticDropdown.customPollutance.potentiallyHarmless"),
         value: t("staticDropdown.customPollutance.potentiallyHarmless")
      },
      {
         label: t("staticDropdown.customPollutance.potentiallyHarmful"),
         value: t("staticDropdown.customPollutance.potentiallyHarmful")
      },
      {
         label: t("staticDropdown.customPollutance.harmlessChecked"),
         value: t("staticDropdown.customPollutance.harmlessChecked")
      },
      {
         label: t("staticDropdown.customPollutance.harmfulChecked"),
         value: t("staticDropdown.customPollutance.harmfulChecked")
      }
   ];

   const showClusterModal = () => {
      setSelectedMenuKey(1);
      if (onSaleCount !== 0) {
         setIsModalVisibleOnSale(true);
      } else {
         setIsClusterModalVisible(true);
      }
   };

   const handleClusterCancel = () => {
      setIsClusterModalVisible(false);
   };

   const onThisFinishFailed = (errorInfo: any) => {
      console.log("Failed:", errorInfo);
   };

   const showPassportDetails = (passport: any) => {
      Mixpanel.track("View Passport Details", {
         "Passport Id": passport.id
      });
      history.push({
         pathname: `${pathname}/passports/${passport.id}`,
         state: { passport, material }
      });
   };

   const handleEditCluster = () => {
      setSelectedMenuKey(2);
      if (onSaleCount !== 0) {
         setIsModalVisibleOnSale(true);
      } else {
         history.push({
            pathname: `${pathname}/edit/passport_cluster`,
            state: { passportCluster, material }
         });
      }
   };

   const editMenu = (
      <Menu>
         <Menu.Item key="1" onClick={showClusterModal}>
            {t("reusePotentialSteps.editCluster")}
         </Menu.Item>

         {!!hasAgGridBulkEditFeature && (
            <Menu.Item key="2" onClick={handleEditCluster}>
               Edit individual passport(s) of cluster
            </Menu.Item>
         )}
      </Menu>
   );

   const totalAmount = ({ passports }: any) => {
      let total = 0;
      passports.forEach((item: any) => {
         total = parseFloat(total + item.amount);
      });

      console.log(total);

      return total;
   };

   const onSubmitHandler = async (values: any) => {
      const axios = await getAxiosInstance();
      axios
         .put(Resource.path.createPassportItemHub + `/${material.id}`, {
            ...values
         })
         .then(() => {
            message.success(t("reusePotentialSteps.successMessage"));

            Mixpanel.track(Events.Add_Passports_With_Same_Conditions.name, {
               "Passport Condition": values?.condition,
               "Passport Deconstructability": values?.deconstructability,
               "Passport Custom Pollutance": values?.custom_pollutance
            });

            setIsClusterModalVisible(false);
            refetch();
         })
         .catch((error) => {
            console.log(error);
            message.error("Some error occurred while processing this request");
            setIsClusterModalVisible(false);
         });
   };

   const totalRooms: string[] = passportCluster.passports
      .map((passport: any) => {
         return passport.room;
      })
      .flat(1)
      .filter(Boolean);

   const uniqueRooms =
      totalRooms && totalRooms.length
         ? totalRooms
              .filter((c, index) => {
                 return totalRooms.indexOf(c) === index;
              })
              .map((room) => {
                 return <Tag>{room}</Tag>;
              })
         : "";

   const passportImageLists =
      passportCluster?.passport_images?.length >= 1
         ? passportCluster.passport_images
         : material?.images?.length >= 1
         ? material?.images
         : [];

   const [{ loading: confirmLoading }, updateSelling] = useAxios(
      {
         url: `${Resource.path.operationsHub}/removeFromSelling/${material.id}`,
         method: "DELETE"
      },
      { manual: true, useCache: false }
   );

   const stopSelling = async () => {
      await updateSelling({
         data: {
            condition: passportCluster.condition,
            custom_pollutance: passportCluster.custom_pollutance,
            deconstructability: passportCluster.deconstructability,
            amount_unit: passportCluster.amount_unit
         }
      })
         .then((resp: any) => {
            setOnSaleCount(0);
            setIsModalVisibleOnSale(false);
            if (selectedMenuKey === 1) {
               setIsClusterModalVisible(true);
            } else if (selectedMenuKey === 2) {
               history.push({
                  pathname: `${pathname}/edit/passport_cluster`,
                  state: { passportCluster, material }
               });
            }
         })
         .catch((error) => {
            console.log(error);
         });
   };

   return (
      <>
         <div className="passport-item">
            {!!passportImageLists?.length && (
               <figure>
                  {passportImageLists.map((image: any) => {
                     return (
                        <Image
                           width={120}
                           height={120}
                           src={getImagePath(image) || "error"}
                           fallback="data:image/png;base64,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"
                        />
                     );
                  })}
               </figure>
            )}
            <div className="passport-details">
               <dl>
                  <dt>{t("materialDashboard.condition")}</dt>
                  <dd>{passportCluster.condition}</dd>
                  <dt>{t("materialDashboard.deconstructability")}</dt>
                  <dd>{passportCluster.deconstructability}</dd>
                  {passportCluster.custom_pollutance && (
                     <>
                        <dt>{t("materialDashboard.pollutance")}</dt>
                        <dd>{passportCluster.custom_pollutance}</dd>
                     </>
                  )}

                  {uniqueRooms ? (
                     <>
                        <dt>Rooms</dt>
                        <dd>{uniqueRooms}</dd>
                     </>
                  ) : (
                     ""
                  )}
               </dl>
               <div className="actions">
                  <b>
                     {totalAmount(passportCluster) % 1 != 0
                        ? String(
                             totalAmount(passportCluster).toFixed(2)
                          ).replace(".", ",")
                        : totalAmount(passportCluster)}{" "}
                     {material.product_unit}
                  </b>
                  <Button
                     type="primary"
                     onClick={() => {
                        showAddModal(passportCluster);
                     }}
                  >
                     {t("default.add")}
                  </Button>
                  <Dropdown overlay={editMenu}>
                     <Button
                        type="text"
                        shape="circle"
                        icon={<EditOutlined />}
                        onClick={(e) => e.preventDefault()}
                     ></Button>
                  </Dropdown>
               </div>
            </div>
            <div className="passports">
               <Collapse defaultActiveKey={[0]} ghost>
                  <Panel
                     header={passportCluster.passports.length + " passport(s)"}
                     key="1"
                  >
                     {passportCluster.passports.map((p: any) => {
                        return (
                           p?.passport_identifier && (
                              <PassportIdentifier
                                 identifier={p?.passport_identifier}
                                 locationNote={p?.location_note}
                                 room={p?.room}
                                 onIdentifierClicked={() =>
                                    showPassportDetails(p)
                                 }
                              ></PassportIdentifier>
                           )
                        );
                     })}
                  </Panel>
               </Collapse>
            </div>
         </div>
         <Modal
            title="Edit passports with same conditions"
            visible={isClusterModalVisible}
            footer={null}
            onCancel={handleClusterCancel}
         >
            <Form
               name="basic"
               labelCol={{
                  span: 10
               }}
               wrapperCol={{
                  span: 16
               }}
               initialValues={{
                  condition: passportCluster.condition,
                  deconstructability: passportCluster.deconstructability,
                  custom_pollutance: passportCluster.custom_pollutance
               }}
               onFinish={onSubmitHandler}
               onFinishFailed={onThisFinishFailed}
            >
               <Form.Item
                  name="condition"
                  label={t("passportDetails.condition")}
               >
                  <Select
                     placeholder={t("passportDetails.placeholderCondition")}
                     style={{ minWidth: "120px" }}
                  >
                     {conditions.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                           {item.value}
                        </Select.Option>
                     ))}
                  </Select>
               </Form.Item>

               <Form.Item
                  name="deconstructability"
                  label={t("passportDetails.deconstructability")}
               >
                  <Select
                     placeholder={t(
                        "passportDetails.placeholderDeconstructability"
                     )}
                     style={{ minWidth: "120px" }}
                  >
                     {deconstructability.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                           {item.value}
                        </Select.Option>
                     ))}
                  </Select>
               </Form.Item>

               <Form.Item
                  name="custom_pollutance"
                  label={t("passportDetails.customPollutance")}
               >
                  <Select
                     placeholder={t(
                        "passportDetails.placeholderCustomPollutance"
                     )}
                     style={{ minWidth: "120px" }}
                  >
                     {customPollutance.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                           {item.value}
                        </Select.Option>
                     ))}
                  </Select>
               </Form.Item>
               <Form.Item
                  wrapperCol={{
                     offset: 8,
                     span: 16
                  }}
               >
                  <Button type="primary" htmlType="submit">
                     Save for all {passportCluster?.passports?.length} passports
                  </Button>
               </Form.Item>
            </Form>
         </Modal>
         <Modal
            title="Some items of this material are on sale in the operation."
            onCancel={() => {
               setIsModalVisibleOnSale(false);
            }}
            confirmLoading={confirmLoading}
            onOk={stopSelling}
            okText="Stop selling and continue"
            closable={false}
            visible={isModalVisibleOnSale}
         >
            <p>You have to stop the selling to continue.</p>
            <p>You might lose existing requests.</p>
         </Modal>
      </>
   );
};

export const PassportList = ({
   material,
   setPassportList,
   showAddPassport,
   fetch
}: any) => {
   const [passports, setPassports] = useState<any>([]);
   const [isModalVisible, setIsModalVisible] = useState(false);
   const [t] = useTranslation();
   const [passportFormInitialValue, setPassportFormInitialValue] = useState({});
   const [addItemLoading, setAddItemLoading] = useState(false);

   const [onLoadAddModal, setOnLoadAddModal] = useState(false);

   const conditions = [
      {
         label: t("staticDropdown.condition.originalPacked"),
         value: t("staticDropdown.condition.originalPacked")
      },
      {
         label: t("staticDropdown.condition.new"),
         value: t("staticDropdown.condition.new")
      },
      {
         label: t("staticDropdown.condition.likeNew"),
         value: t("staticDropdown.condition.likeNew")
      },
      {
         label: t("staticDropdown.condition.refurbished"),
         value: t("staticDropdown.condition.refurbished")
      },
      {
         label: t("staticDropdown.condition.signOfUsages"),
         value: t("staticDropdown.condition.signOfUsages")
      },
      {
         label: t("staticDropdown.condition.signOfAge"),
         value: t("staticDropdown.condition.signOfAge")
      },
      {
         label: t("staticDropdown.condition.heavilyUsed"),
         value: t("staticDropdown.condition.heavilyUsed")
      },
      {
         label: t("staticDropdown.condition.damaged"),
         value: t("staticDropdown.condition.damaged")
      },
      {
         label: t("staticDropdown.condition.broken"),
         value: t("staticDropdown.condition.broken")
      }
   ];
   const deconstructability = [
      {
         label: t("staticDropdown.deconstructability.easyLoose"),
         value: t("staticDropdown.deconstructability.easyLoose")
      },
      {
         label: t("staticDropdown.deconstructability.easyPlugged"),
         value: t("staticDropdown.deconstructability.easyPlugged")
      },
      {
         label: t("staticDropdown.deconstructability.easyScrewed"),
         value: t("staticDropdown.deconstructability.easyScrewed")
      },
      {
         label: t("staticDropdown.deconstructability.easyBuild"),
         value: t("staticDropdown.deconstructability.easyBuild")
      },
      {
         label: t("staticDropdown.deconstructability.moderateBuild"),
         value: t("staticDropdown.deconstructability.moderateBuild")
      },
      {
         label: t("staticDropdown.deconstructability.elaborateBuild"),
         value: t("staticDropdown.deconstructability.elaborateBuild")
      },
      {
         label: t("staticDropdown.deconstructability.hardSpecialSkillsNeeded"),
         value: t("staticDropdown.deconstructability.hardSpecialSkillsNeeded")
      },
      {
         label: t("staticDropdown.deconstructability.notEconomicallyFeasible"),
         value: t("staticDropdown.deconstructability.notEconomicallyFeasible")
      },
      {
         label: t("staticDropdown.deconstructability.notPossible"),
         value: t("staticDropdown.deconstructability.notPossible")
      }
   ];

   const customPollutance = [
      {
         label: t("staticDropdown.customPollutance.unknown"),
         value: t("staticDropdown.customPollutance.unknown")
      },
      {
         label: t("staticDropdown.customPollutance.toBeProved"),
         value: t("staticDropdown.customPollutance.toBeProved")
      },
      {
         label: t("staticDropdown.customPollutance.potentiallyHarmless"),
         value: t("staticDropdown.customPollutance.potentiallyHarmless")
      },
      {
         label: t("staticDropdown.customPollutance.potentiallyHarmful"),
         value: t("staticDropdown.customPollutance.potentiallyHarmful")
      },
      {
         label: t("staticDropdown.customPollutance.harmlessChecked"),
         value: t("staticDropdown.customPollutance.harmlessChecked")
      },
      {
         label: t("staticDropdown.customPollutance.harmfulChecked"),
         value: t("staticDropdown.customPollutance.harmfulChecked")
      }
   ];

   const [{ data, loading: getLoading, error: getError }, refetch] = useAxios(
      {
         url: `${Resource.path.getClusteredPassportsHub}/invent/${material.id}`,
         method: "GET"
      },
      { useCache: false }
   );

   useEffect(() => {
      if (data?.data) {
         const passports = data?.data;
         if (passports) {
            setPassports(passports);
            setPassportList(passports);
         }
      }
   }, [data]);

   useEffect(() => {
      if (showAddPassport && !onLoadAddModal) {
         setIsModalVisible(true);
         setPassportFormInitialValue({});
         setOnLoadAddModal(false);
      }
   }, [showAddPassport, onLoadAddModal]);

   if (getLoading) {
      (window as any).NProgress.start();
   } else {
      (window as any).NProgress.done();
   }

   if (getLoading)
      return (
         <div className="loading">
            <Spin tip={t("common.loading")} />
         </div>
      );

   const showAddModal = () => {
      setIsModalVisible(true);
      setPassportFormInitialValue({});
   };

   const addPassportToCluster = (passportCluster: any) => {
      setPassportFormInitialValue({
         condition: passportCluster.condition,
         deconstructability: passportCluster.deconstructability,
         custom_pollutance: passportCluster.custom_pollutance
      });
      setIsModalVisible(true);
   };

   const handleCancel = () => {
      setIsModalVisible(false);
   };

   const onFinish = async (values: any) => {
      console.log(values);
      if (addItemLoading) return;

      setAddItemLoading(true);

      const passportImagesLinks =
         await getPassportWithUploadedMaterialImagesLinks(values, material.id);

      const axios = await getAxiosInstance();
      axios
         .post(Resource.path.createPassportItemHub + `/${material.id}`, {
            ...values,
            amount: values.amount ? values.amount.replace(",", ".") : 1,
            passport_images: passportImagesLinks,
            amount_unit: material.product_unit
         })
         .then(() => {
            message.success(t("reusePotentialSteps.successMessage"));

            Mixpanel.track(Events.Add_Passports.name, {
               "Material Id": material.id,
               "Passport Amount": values.amount
                  ? values.amount.replace(",", ".")
                  : 1,
               "Passport Amount Unit": material.product_unit,
               "Passport Condition": values?.condition,
               "Passport Deconstructability": values?.deconstructability,
               "Passport Custom Pollutance": values?.custom_pollutance
            });

            setIsModalVisible(false);
            setAddItemLoading(false);
            fetch && fetch();
            refetch();
         })
         .catch((error) => {
            console.log(error);
            message.error("Some error occurred while processing this request");
            setIsModalVisible(false);
            setAddItemLoading(false);
         });
   };

   const onFinishFailed = (errorInfo: any) => {
      console.log("Failed:", errorInfo);
   };

   const rooms = [""];
   /*for (let i = 10; i < 30; i++) {
    rooms.push(
      <Option value={i.toString(36) + i} key={i.toString(36) + i}>
        {i.toString(36) + i}
      </Option>
    );
  }*/

   return (
      <>
         <div className="passport-list-header">
            {material.total_amount && (
               <h2>
                  {t("materialDashboard.availableAmount")} /{" "}
                  {t("materialDashboard.passports")}
               </h2>
            )}
            <p>
               {material.total_amount && (
                  <>
                     {material.total_amount % 1 != 0
                        ? String(
                             parseFloat(material.total_amount).toFixed(2)
                          ).replace(".", ",")
                        : material.total_amount}{" "}
                     {material.product_unit} {t("materialDashboard.available")}
                  </>
               )}
               <Button type="primary" onClick={showAddModal}>
                  {t("default.add")}
               </Button>
            </p>
         </div>
         <div className="passport-list">
            {passports.map((passportCluster: any, index: number) => {
               return (
                  <PassportCluster
                     passportCluster={passportCluster}
                     key={index}
                     material={material}
                     refetch={refetch}
                     showAddModal={addPassportToCluster}
                  />
               );
            })}
         </div>
         <Modal
            title={t("default.add")}
            visible={isModalVisible}
            footer={null}
            onCancel={handleCancel}
            destroyOnClose
         >
            <Form
               name="basic"
               labelCol={{
                  span: 10
               }}
               wrapperCol={{
                  span: 16
               }}
               onFinish={onFinish}
               initialValues={passportFormInitialValue}
               onFinishFailed={onFinishFailed}
            >
               <Form.Item name="amount" label={t("passportDetails.amount")}>
                  <Input
                     defaultValue={1}
                     style={{ width: "100px" }}
                     suffix={material.product_unit}
                  />
               </Form.Item>

               <Form.Item
                  name="condition"
                  label={t("passportDetails.condition")}
                  rules={[
                     {
                        required: true,
                        message: t("passportDetails.selectCondition")
                     }
                  ]}
               >
                  <Select
                     placeholder={t("passportDetails.placeholderCondition")}
                     style={{ minWidth: "120px" }}
                  >
                     {conditions.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                           {item.value}
                        </Select.Option>
                     ))}
                  </Select>
               </Form.Item>

               <Form.Item
                  name="deconstructability"
                  label={t("passportDetails.deconstructability")}
                  rules={[
                     {
                        required: true,
                        message: t(
                           "passportDetails.requiredDeconstructabilityMessage"
                        )
                     }
                  ]}
               >
                  <Select
                     placeholder={t(
                        "passportDetails.placeholderDeconstructability"
                     )}
                     style={{ minWidth: "120px" }}
                  >
                     {deconstructability.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                           {item.value}
                        </Select.Option>
                     ))}
                  </Select>
               </Form.Item>

               <Form.Item
                  name="custom_pollutance"
                  label={t("passportDetails.customPollutance")}
               >
                  <Select
                     placeholder={t(
                        "passportDetails.placeholderCustomPollutance"
                     )}
                     style={{ minWidth: "120px" }}
                  >
                     {customPollutance.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                           {item.value}
                        </Select.Option>
                     ))}
                  </Select>
               </Form.Item>
               <Form.Item
                  name="contact_polluted_material"
                  label={t("passportDetails.contactPollutedMaterial")}
               >
                  <Switch />
               </Form.Item>
               <Form.Item
                  label={t("default.room")}
                  name="room"
                  rules={[
                     {
                        required: false,
                        message: "Please enter a room"
                     }
                  ]}
               >
                  <Select
                     mode="tags"
                     placeholder={t("passportDetails.addOrSelectRoom")}
                  >
                     {rooms}
                  </Select>
               </Form.Item>
               <Form.Item
                  name="location_note"
                  label={t("passportDetails.locationNote")}
               >
                  <Input.TextArea
                     placeholder={t("passportDetails.placeholderLocationNote")}
                  />
               </Form.Item>

               <Form.Item
                  name="other_note"
                  label={t("passportDetails.otherNote")}
               >
                  <Input.TextArea
                     placeholder={t("passportDetails.placeholderOtherNote")}
                  />
               </Form.Item>

               <Form.Item
                  name="passport_images"
                  label={t("passportDetails.uploadImage")}
               >
                  <ImageUploader></ImageUploader>
               </Form.Item>

               <Form.Item
                  wrapperCol={{
                     offset: 8,
                     span: 16
                  }}
               >
                  <Button
                     type="primary"
                     htmlType="submit"
                     loading={addItemLoading}
                  >
                     {t("default.save")}
                  </Button>
               </Form.Item>
            </Form>
         </Modal>
      </>
   );
};
